import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '@/tailwind.config.js'

const twcfg = resolveConfig(tailwindConfig)

export default ({ app }, inject) => {
    inject('twcfg', twcfg)
}
